import { ImageDimension } from '@lib-ui/lib/models/image-dimension';

export interface ImageUploadData {
  name: string,
  file: File,
  fileString: string,
  dimensions: ImageDimension
}
